import React, { useContext } from "react";
import FullScreenOverlay from "./overlay/FullScreenOverlay";
import DialogBoxComponent from "./dialogs/DialogBoxComponent";
import BOStageLogo from "../../assets/images/footer-logologin.png";
import { useNavigate } from "react-router";
import LayoutContext from "../../LayoutContext";
import AppContext from "../../AppContext";
import PopupContext from "../../PopupContext";

export default function PopupManager() {
    /* #region VARS */
    const navigate = useNavigate();
    const { showIsSubscribedPopup, setShowIsSubscribedPopup, isLoadingAccountPage } = useContext(LayoutContext);
    const { showOnboardingCompletedPopup, setShowOnboardingCompletedPopup } = useContext(PopupContext);
    const { isLoadingApp } = useContext(AppContext);
    const { genericConfirmationPopup } = React.useContext(PopupContext);
    /* #endregion */

    return (
        <div>
            <FullScreenOverlay show={showIsSubscribedPopup && !isLoadingApp && !isLoadingAccountPage}>
                <DialogBoxComponent
                    title="Subscribed!"
                    message={
                        "<div style='font-size: 14px; margin: 0 -5px;'>Thank you for subscribing to BOtag trial period. We will send you a reminder email 7 days prior to the end of the trial period.<br /><br />You can now continue activating your account.</div>"
                    }
                    onClickYes={() => {
                        setShowIsSubscribedPopup(false);
                        navigate("/account/create");
                    }}
                    useImageHeader={{ src: BOStageLogo, width: "165px" }}
                    showCancel={false}
                    confirmText="CONTINUE"
                    confirmState="secondary"
                    confirmWidth="150px"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showOnboardingCompletedPopup && !isLoadingApp && !isLoadingAccountPage}>
                <DialogBoxComponent
                    heading="Success!"
                    headingColor="var(--text-icons-green-500)"
                    title="Onboarding Completed!"
                    message={`<div style='font-size: 14px; margin: 0 -10px;'>
                            You have finished onboarding your POS in BOstageX.<br />You can now proceed to operate your account.
                        </div>`}
                    onClickYes={() => {
                        setShowOnboardingCompletedPopup(false);
                    }}
                    showCancel={false}
                    confirmText="CLOSE"
                    confirmState="secondary"
                    confirmWidth="150px"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={genericConfirmationPopup?.show === true}>
                <DialogBoxComponent {...genericConfirmationPopup} />
            </FullScreenOverlay>
        </div>
    );
}
